import React, { useId } from 'react';

/**
 * Brand-styled game icons (gradient) to match home hero / leaderboard title.
 * Use tone="onAccent" when the icon sits on a solid accent background (e.g. active tab).
 */
function gradientStops(tone) {
  if (tone === 'onAccent') {
    return <stop offset="100%" stopColor="#ffffff" />;
  }
  return (
    <>
      <stop offset="0%" stopColor="var(--brand-logo, #6a1b9a)" />
      <stop offset="100%" stopColor="var(--accent-secondary, #e8a898)" />
    </>
  );
}

export function LetterHiveBrandIcon({ className, tone = 'brand', title }) {
  const uid = useId().replace(/:/g, '');
  const gradId = `lq-hive-${uid}`;
  const fill = tone === 'onAccent' ? '#ffffff' : `url(#${gradId})`;

  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      {tone !== 'onAccent' ? (
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            {gradientStops(tone)}
          </linearGradient>
        </defs>
      ) : null}
      {/* Flat-top hex cell with center cutout (hive / honeycomb) */}
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8 10h16l4 6-4 6H8l-4-6 4-6zM16 12a4 4 0 100 8 4 4 0 000-8z"
      />
    </svg>
  );
}

export function WordRungsBrandIcon({ className, tone = 'brand', title }) {
  const uid = useId().replace(/:/g, '');
  const gradId = `lq-rungs-${uid}`;
  const stroke = tone === 'onAccent' ? '#ffffff' : `url(#${gradId})`;

  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      {tone !== 'onAccent' ? (
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="0%" y2="100%">
            {gradientStops(tone)}
          </linearGradient>
        </defs>
      ) : null}
      <g fill="none" stroke={stroke} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 5v22M21 5v22" />
        <path d="M11 9h10M11 15h10M11 21h10" />
      </g>
    </svg>
  );
}
